<template>
    <div class="border p-2 mt-4">
        <form @submit.prevent="saveLimitation" id="deposit_limitation_form">
            <kt-form-group v-if="!deposit.has_limit" style="margin-top: 10px;">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="has_limit1" name="has_limit"
                           v-model="deposit.has_limit">
                    <label class="custom-control-label" for="has_limit1">{{ $t('label.amount_limitation') }}</label>
                </div>
            </kt-form-group>

            <div class="container p-3 pt-5 my-4 border in-border-header" v-if="deposit.has_limit">
                <kt-form-section is_first>
                    <div class="section-header" style="right: -5px;">
                        <kt-form-group class="mb-0">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                       v-model="deposit.has_limit">
                                <label class="custom-control-label" for="has_limit2">{{ $t('label.amount_limitation') }}</label>
                            </div>
                        </kt-form-group>
                    </div>

                    <kt-form-group v-if="deposit.has_limit">
                        <kt-form-label>
                            {{ $t('label.limit_amount') }}
                        </kt-form-label>
                        <div class="kt-input-icon kt-input-icon--left">
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('label.rial') }}</span>
                        </span>
                            <kt-form-control
                                    type="text"
                                    dir="ltr"
                                    id="limit_amount"
                                    name="limit_amount"
                                    v-model="deposit.limit_amount"
                            >
                            </kt-form-control>
                        </div>
                    </kt-form-group>
                </kt-form-section>
            </div>

            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input
                            type="checkbox"
                            class="custom-control-input"
                            id="server_ip_limitation"
                            name="server_ip_limitation"
                            v-model="deposit.server_ip_limitation"
                    >
                    <label class="custom-control-label" for="server_ip_limitation">{{
                        $t('label.server_ip_limitation') }}</label>
                </div>
            </kt-form-group>
            <div>
                <button type="submit"
                        class="btn btn-success"
                        id="deposit_save_limitation"
                        v-text="$t('btn.submit_changes')"
                >
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import $ from "jquery";
    import {KTApp} from "@/plugins/core/app";
    import {depositPfService, depositStarshopService} from "@/common/api.service"
    import {i18n} from "@/plugins/i18n";

    export default {
        props: {
            deposit: {
                required: true,
            }
        },
        data() {
            return {
                depositPfService,
                depositStarshopService
            };
        },
        computed: {
            gatewaySource() {
                return this.$route.params.gateway_source;
            },
            apiService() {
                return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
            },
        },
        methods: {
            saveLimitation(e) {
                let btn = $('#deposit_save_limitation');
                let form = $('#deposit_limitation_form');

                form.validate({
                    rules: {
                        limit_amount: {
                            required: this.deposit.has_limit,
                            min: 1000,
                            digits: true
                        }
                    }
                });

                if (!form.valid()) {
                    return
                }

                KTApp.progress(btn);

                this.apiService.adminChangeLimitation(this.$route.params.hashid, {
                    has_limit: this.deposit.has_limit,
                    server_ip_limitation: this.deposit.server_ip_limitation,
                    limit_amount: this.deposit.limit_amount,
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
                })
                .finally(response => {
                        KTApp.unprogress(btn);
                        this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
                    }
                )
            },
        },
    }
</script>

<style>
</style>
